
export const Routes = {
    // pages
    Login: { path: "/login" },
    DashboardOverview: { path: "/dashboard/overview" },
    Transactions: { path: "/transactions" },
    Settings: { path: "/settings" },
    Upgrade: { path: "/upgrade" },
    BootstrapTables: { path: "/tables/bootstrap-tables" },
    Billing: { path: "/examples/billing" },
    Invoice: { path: "/examples/invoice" },
    ForgotPassword: { path: "/examples/forgot-password" },
    ResetPassword: { path: "/examples/reset-password" },
    NotFound: { path: "/errors/404" },
    ServerError: { path: "/errors/500" },

    // management pages
    Classes: { path: "/management/classes" },
    Students: { path: "/management/students" },
    Teachers: { path: "/management/teachers" },
    Subjects: { path: "/management/subjects" },
    CoordinatorLessonPlan: { path: "/management/coordinator-lesson-plan" },
    CoordinatorEnrollments: { path: "/management/coordinator-enrollments" },
    SchoolSettings: { path: "/management/school-settings" },
    Profile: { path: "/profile" },

    // teacher pages
    TeacherClasses: { path: "/teacher/classes" },
    TeacherStudents: { path: "/teacher/students" },
    TeacherLessonPlans: { path: "/teacher/lesson-plans" },
    TeacherClassContent: { path: "/teacher/class-content" },
    TeacherAttendance: { path: "/teacher/attendance" },
    TeacherGrades: { path: "/teacher/grades" },

    // municipal pages
    MunicipalSchools: { path: "/municipal/schools" },
    MunicipalStaff: { path: "/municipal/staff" },

    // auth pages
    SetPassword: { path: "/set-password/:token" },

    // docs
    DocsOverview: { path: "/documentation/overview" },
    DocsDownload: { path: "/documentation/download" },
    DocsQuickStart: { path: "/documentation/quick-start" },
    DocsLicense: { path: "/documentation/license" },
    DocsFolderStructure: { path: "/documentation/folder-structure" },
    DocsBuild: { path: "/documentation/build-tools" },
    DocsChangelog: { path: "/documentation/changelog" },

    // components
    Accordions: { path: "/components/accordions" },
    Alerts: { path: "/components/alerts" },
    Badges: { path: "/components/badges" },
    Widgets: { path: "/widgets" },
    Breadcrumbs: { path: "/components/breadcrumbs" },
    Buttons: { path: "/components/buttons" },
    Forms: { path: "/components/forms" },
    Modals: { path: "/components/modals" },
    Navs: { path: "/components/navs" },
    Navbars: { path: "/components/navbars" },
    Pagination: { path: "/components/pagination" },
    Popovers: { path: "/components/popovers" },
    Progress: { path: "/components/progress" },
    Tables: { path: "/components/tables" },
    Tabs: { path: "/components/tabs" },
    Tooltips: { path: "/components/tooltips" },
    Toasts: { path: "/components/toasts" },
    WidgetsComponent: { path: "/components/widgets" }
};
